import { financeService } from './financeService';

export const salaryFieldService = {
  getAllSalaryFields: () => financeService.getAllSalaryFields(),
  getSalaryFieldById: (id) => financeService.getSalaryFieldById(id),
  getCompanyPayrollComponents: (orgId) => financeService.getCompanyPayrollComponents(orgId),
  saveCompanyPayrollComponents: (orgId, salaryFieldIds) =>
    financeService.saveCompanyPayrollComponents(orgId, salaryFieldIds),
  generateSalaryBatch: (params, month, year) =>
    financeService.generateSalaryBatch(params, month, year),
  batchGenerateSalary: (params, month, year) =>
    financeService.batchGenerateSalary(params, month, year),
};

export default salaryFieldService;
